const { withAppConfig } = require("../../../appConfigContext");
const { FFE_STEPS, DEFAULT_STEPS } = require("./constants");

const WithShipmentSelectionHOC = (Component) => {
  return withAppConfig((props) => {
    const showDateRange = props.configJSON?.showDateRangeInShipmentSelection;
    const Steps = showDateRange ? FFE_STEPS : DEFAULT_STEPS;
    return <Component steps={Steps} showDateRange={showDateRange} {...props} />;
  });
};

export { WithShipmentSelectionHOC };
